import { render, staticRenderFns } from "./visitInfo.vue?vue&type=template&id=000c8d35&scoped=true&"
import script from "./visitInfo.vue?vue&type=script&lang=js&"
export * from "./visitInfo.vue?vue&type=script&lang=js&"
import style0 from "./visitInfo.vue?vue&type=style&index=0&id=000c8d35&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000c8d35",
  null
  
)

export default component.exports